import React from "react";


import { Link } from "react-router-dom";
import InspectionServiceSection from "../components/Inspections-services";

const IndusterialPage = () => {

const inspectionServiceData = {
    image: "./images/Industrial_Building.jpg",
    description: `We conduct a detailed visual and structural review of industrial buildings. This covers electrical, roofing, plumbing, flashing, chimneys, fire & safety and mechanical systems. Buildings covered under such inspections include industrial complexes, warehouses, retail stores, farmland and agricultural industry units, industrial manufacturing plants, and commercial establishments.`,
    subtitle: "We use ASTM Standard E2018-15 for Commercial Buildings, in that a five-year time frame for major repairs or replacements of building components has been considered.", // Optional <h5> if needed
    title: "Our commercial inspections include, (but not limited to):",
    checklist: [
        "Roofing",
        "Exteriors",
        "Structure",
        "HVAC System",
        "Interiors",
        "Electrical",
        "Plumbing",
        "And more"
    ]
};
   
  

  return (
    <>
      <div class="common-001">
        <section className="section-banner">
          <div className="container">
            <div className="inner-content">
              <p>Fast, Reliable Home Inspections for Agents & Homeowners</p>
              <h1>
                Industrial<span> Building</span>
              </h1>
              <p>
                Discover peace of mind with our expert home inspection services,
                designed to meet the needs of both real estate agents and
                property owners. Our team ensures thorough evaluations and
                prompt reporting, helping you make informed decisions.
              </p>
              <div className="dft-btn">
                <Link to="/contact-us" className="btn">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </section>


<InspectionServiceSection data={inspectionServiceData} />
        
      </div>
    </>
  );
};

export default IndusterialPage;
